import { render, staticRenderFns } from "./PresentacionesProcessAdmin.vue?vue&type=template&id=670988f3&scoped=true&"
import script from "./PresentacionesProcessAdmin.vue?vue&type=script&lang=js&"
export * from "./PresentacionesProcessAdmin.vue?vue&type=script&lang=js&"
import style0 from "./PresentacionesProcessAdmin.vue?vue&type=style&index=0&id=670988f3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670988f3",
  null
  
)

export default component.exports